import $ from 'jquery';
import { BREAKPOINTS } from "./breakpoints";

export default class ImageModal {
   constructor() {
      this.$window = $(window);
      this.$body = $('body');
      this.windowWidth = window.innerWidth; // ブラウザのスクロールバーも含めて横幅を取得
      this.windowHeight = window.innerHeight;

      this.imageModal();
   }

   // image modal
   // TODO: 後でちゃんとリファクタする
   // TODO: 閉じる時にチラつきがウザいためモーダルオープン中スクロール許可している
   imageModal() {
      const $imageModalMask = $('.js-imageModalMask');
      const $imageModalImage = $('.js-imageModalImage');
      const $imageModalCaption = $('.js-imageModalCaption')
      let imagesLength = null;
      let currentImageIndex = null;
      // let scrollPosition = null;
      $('.js-imageModalTrigger').on('click', (e) => {
         const modalState = this.$body.attr('data-image-modal-state');
         const caption = $(e.currentTarget).attr('data-image-modal-caption');
         currentImageIndex = parseInt($(e.currentTarget).attr('data-image-modal-index'), 10);
         if (!imagesLength) {
            imagesLength = $(e.currentTarget).attr('data-image-modal-length');
         }
         let src = '';
         if (this.windowWidth < BREAKPOINTS.MEDIUM) {
            src = $(e.currentTarget).attr('data-image-modal-src-m');
         } else {
            src = $(e.currentTarget).attr('data-image-modal-src-lg');
         }
         if (!modalState || modalState == 'is-close') {
            // scrollPosition = this.$window.scrollTop();
            // this.$body.attr('data-image-modal-state', 'is-open');
            $imageModalMask.css({
               visibility: 'visible',
               opacity: '1'
            });
            // this.$body.css({
            //     top: -scrollPosition,
            //     height: this.windowHeight
            // });
            $imageModalImage.attr({src: src, alt:caption});
            $imageModalCaption.text(caption);
         }
      });
      $imageModalMask.on('click', () => {
         closeImageModal();
      });

      const closeImageModal = (e) => {
         $imageModalMask.css('opacity', '0'); // opcityとvisibilityは別タイミングで変更する
         $imageModalMask.on('transitionend', () => {
            // this.$body.attr('data-image-modal-state', 'is-close').removeAttr('style');
            $imageModalMask.css('visibility', 'hidden');
            // window.scrollTo(0, scrollPosition);
            $imageModalMask.off('transitionend');
         });
      };

      let touchStartX = null;
      let touchEndX = null;
      $imageModalImage.on('touchmove', (e) => {
         e.preventDefault();
         touchEndX = e.touches[0].pageX;
      });
      $imageModalImage.on('touchstart', (e) => {
         e.preventDefault();
         touchStartX = e.touches[0].pageX;
      });
      $imageModalImage.on('touchend', (e) => {
            e.preventDefault();
         if( 0 < (touchEndX - touchStartX) ) { //右に方向にスワイプ
            switchModalImage('back');
         } else { //左に方向にスワイプ
            switchModalImage('forth');
         }
      });
      $('.js-imageModalPrev').on('click', (e) => {
            e.stopPropagation(); // maskまでイベントを伝播させない
            switchModalImage('back');
      });
      $('.js-imageModalNext').on('click', (e) => {
            e.stopPropagation(); // maskまでイベントを伝播させない
            switchModalImage('forth');
      });

      /**
       * モーダル表示している画像を切り替える
       * @param {string} direction - 'back' or 'forth'
       */
      const switchModalImage = (direction) => {
         console.log('switchModalImage');
            if (direction !== 'back' && direction !== 'forth') {
               return;
            }
            let $nextImageTrigger = null;
            if (direction === 'back') {
               if (currentImageIndex - 1 < 0) {
                  closeImageModal();
                  return;
               }
               $nextImageTrigger = $(`[data-image-modal-index="${currentImageIndex - 1}"]`);
            } else {
               if (currentImageIndex + 1 > imagesLength) {
                  closeImageModal();
                  return;
               }
               $nextImageTrigger = $(`[data-image-modal-index="${currentImageIndex + 1}"]`);
            }
            const nextCaption = $nextImageTrigger.attr('data-image-modal-caption');
            let nextImageSrc = '';
            if (this.windowWidth < BREAKPOINTS.MEDIUM) {
               nextImageSrc = $nextImageTrigger.attr('data-image-modal-src-m');
            } else {
               nextImageSrc = $nextImageTrigger.attr('data-image-modal-src-lg');
            }
            $imageModalImage.attr({src: nextImageSrc, alt:nextCaption});
            $imageModalCaption.text(nextCaption);
            currentImageIndex = direction === 'back' ? currentImageIndex - 1 : currentImageIndex + 1;
      };
   }
};
